export const BRAND_GREEN = "#2F7164";
export const BRAND_GREEN_DARK = "#285F55";
export const WHITE = "#FFFFFF";
export const BLACK_TEXT = "#212121";

export const TEXT_DARK = "#242424";
export const TEXT_DARKER = "#232323";
export const TEXT_MUTED = "#888";
export const TEXT_GRAY = "#A3A3A3";
export const TEXT_DIM = "#AAA";
export const TEXT_FAINT = "#CCC";
export const TEXT_SLATE = "#3F3F3F";

export const BORDER_LIGHT = "#E4EBE7";
export const SURFACE_MINT = "#ECF0EE";
export const SURFACE_GRAY = "#F1F1F1";
export const SURFACE_OFFWHITE = "#F2F5F4";
export const NO_DATA_GRAY = "#D2D2D2";

export const ACCENT_BLUE = "#345FEB";
export const INFO_BLUE = "#01579B";
export const ACCENT_PURPLE = "#9C27B0";

export const TITLE_II_MAP_COLOR: [string, string, string, string, string] = [
    "#F0F9E8",
    "#BAE4BC",
    "#7BCCC4",
    "#43A2CA",
    "#0868AC"
];

export const GREEN_RAMP: [string, string, string, string, string] = [
    "#4D847A",
    "#749F97",
    "#9CBAB4",
    "#B9CDC9",
    "#CDDBD8"
];

export const BRAND_GREEN_00 = "rgba(47, 113, 100, 0)";
export const BRAND_GREEN_05 = "rgba(47, 113, 100, 0.05)";
export const BRAND_GREEN_08 = "rgba(47, 113, 100, 0.08)";
export const BRAND_GREEN_10 = "rgba(47, 113, 100, 0.1)";
export const BRAND_GREEN_12 = "rgba(47, 113, 100, 0.12)";
export const BRAND_GREEN_15 = "rgba(47, 113, 100, 0.15)";
export const BRAND_GREEN_20 = "rgba(47, 113, 100, 0.2)";
export const BRAND_GREEN_28 = "rgba(47, 113, 100, 0.28)";
export const BRAND_GREEN_30 = "rgba(47, 113, 100, 0.3)";
export const BRAND_GREEN_50 = "rgba(47, 113, 100, 0.5)";
export const BRAND_GREEN_70 = "rgba(47, 113, 100, 0.7)";
export const BRAND_GREEN_90 = "rgba(47, 113, 100, 0.9)";

export const WHITE_30 = "rgba(255, 255, 255, 0.3)";
export const WHITE_72 = "rgba(255, 255, 255, 0.72)";
export const WHITE_80 = "rgba(255, 255, 255, 0.8)";
export const WHITE_90 = "rgba(255, 255, 255, 0.9)";

export const SHADOW_FAINT = "rgba(0, 0, 0, 0.1)";
export const SHADOW_LIGHT = "rgba(0, 0, 0, 0.15)";
export const SHADOW_SOFT = "rgba(0, 0, 0, 0.2)";
export const SHADOW_MEDIUM = "rgba(0, 0, 0, 0.5)";
